/**
 * URL-hash keys for the storage-locations feature's deep-linkable overlays,
 * bound via `useHashDialog` / `useHashParamDialog` (see
 * `@/hooks/use-hash-dialog`). Row-scoped overlays carry the entity id as a hash
 * param (`#edit/5`). Creation happens on a dedicated `/new` route, not an
 * overlay, so there is no `create` key.
 */
export const STORAGE_LOCATIONS_HASH = {
  /** `#edit/<id>` — StorageLocationEditDialog for a specific location. */
  edit: 'edit',
  /** `#delete/<id>` — single-location delete confirmation. */
  delete: 'delete',
  /** `#bulk-delete` — bulk delete confirmation (action bar). */
  bulkDelete: 'bulk-delete'
} as const;

export type StorageLocationsHashKey =
  (typeof STORAGE_LOCATIONS_HASH)[keyof typeof STORAGE_LOCATIONS_HASH];
